import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";


export const CALCULATION_ANNUAL_TAX_SEARCH_COLUMNS: Column[] = [

  {
    title: "admin.calculation.annualtax.search.kwfrom",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.fromKw} kw</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.annualtax.search.kwto",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.toKw} kw</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.annualtax.search.price",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.price} $</div>
        </div>
      );
    },
  },
];
